import { Spin } from "antd";
import type { FC } from "react";
import type { StockHolderNumberPoint, StockKlineBar } from "fin-web-components";
import { StockKlineChart } from "fin-web-components";

type Props = {
  dayKlines: StockKlineBar[] | null;
  klineLoading: boolean;
  holderNumbers: StockHolderNumberPoint[] | null;
};

export const StockDetailKlineSection: FC<Props> = ({ dayKlines, klineLoading, holderNumbers }) => {
  const klines = dayKlines ?? [];

  return (
    <section className="lf-stock-detail-kline">
      {klineLoading ? (
        <Spin tip="加载行情中...">
          <div className="lf-stock-detail-kline__placeholder" />
        </Spin>
      ) : klines.length === 0 ? (
        <div className="lf-stock-detail-kline__empty">暂无行情数据</div>
      ) : (
        <StockKlineChart dayKlines={klines} holdersData={holderNumbers} />
      )}
    </section>
  );
};
